import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { htmlSafe, type SafeString } from '@ember/template';

import type { PopupData, Service } from 'webapp-types';
import { TeamMemberStatus } from 'webapp/enums/enums';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerContextComponent from 'webapp/components/popup/inner/context';

import type Team from 'webapp/models-custom/team';

export default class TeamsViewPopupListComponent extends PopupInnerContextComponent<PopupData.Teams.List> {
	@service('model-manager/teams') declare mmTeamsService: Service.ModelManager.Teams;
	@service('navigation') declare navigationService: Service.Navigation;

	get filteredTeams() {
		const userId = this.mmTeamsService.currentUserId;

		return this.mmTeamsService.userTeamModels.filter(
			(team) =>
				team.numericId !== this.popupData.excludeId &&
				team.teamMembers.some(
					(member) => member.id === userId && member.status === TeamMemberStatus.MEMBER,
				),
		);
	}

	@action
	openTeam(team: Team) {
		this.navigationService.replaceRoute(`/teams/${team.id}`);
	}

	@action
	openAllTeams() {
		this.navigationService.replaceRoute('/teams');
	}

	setBackgroundColor(team: Team): SafeString {
		return htmlSafe(`background-color: ${team.color}`);
	}

	<template>
		<div class="teams-view-popup-list__wrapper">
			<div class="teams-view-popup-list">
				{{#each this.filteredTeams as |team|}}
					<div
						role="button"
						class="teams-view-popup-list__item"
						{{on "click" (fn this.openTeam team)}}
					>
						<div
							class="teams-view-popup-list__item-icon-wrapper"
							style={{this.setBackgroundColor team}}
						>
							<CommonUiIconComponent @name="Spaces" @size="sm" />
						</div>
						<div class="teams-view-popup-list__item-text">{{team.name}}</div>
						{{#if team.isClosed}}
							<CommonUiIconComponent @name="Lock" @size="sm" />
						{{else if team.isPrivate}}
							<CommonUiIconComponent @name="EyeClosed" @size="sm" />
						{{/if}}
					</div>
				{{/each}}
			</div>
			<div
				role="button"
				class="teams-view-popup-list__all-teams"
				{{on "click" this.openAllTeams}}
			>
				All spaces
			</div>
		</div>
	</template>
}
